
export const SET_CURRENT_IMAGE_INDEX = "SET_CURRENT_IMAGE_INDEX"

export const setCurrentImageIndex = (index) => {
    return {
      type: SET_CURRENT_IMAGE_INDEX,
      payload: index,
    };
  };


// WEBPACK FOOTER //
// ./actions/carouselActions.jsx